import React, { useEffect, Fragment } from "react";
import FormValidators from "../FormValidators/index";
import NonHostedLinks from "./NonHostedLinks";
import { Field, reduxForm } from "redux-form";
import { UpwardReduxInput } from "../ui";
import axios from "axios";

const PhoneForm = (props) => {

    const sessionId = window.currentJob && window.currentJob.sessionId ? window.currentJob.sessionId : '';    

    useEffect(() => {
        document.getElementById("phone").select();
        document.getElementById("phone").focus();
    }, []);

    function formatPhoneChange(input){
        input = input.replace(/\D/g,'');

        input = input.substring(0,10);

        var size = input.length;
        if(size === 0){
                input = input;
        }else if(size < 4){
                input = '('+input;
        }else if(size < 7){
                input = '('+input.substring(0,3)+')'+input.substring(3,6);
        }else{
                input = '('+input.substring(0,3)+')'+input.substring(3,6)+'-'+input.substring(6,10);
        }
        return input;
    }

    function formatNum(e) {
        props.updatePhone(formatPhoneChange(e.target.value))
    }


    const handleSubmit = e => {
        props.showLoad();
        axios.all([
            axios.get(process.env['REACT_APP_API_URL'] + "/search/internalPost2.fsn?OID=3003&" + props.queryString),
            axios.get(process.env['REACT_APP_API_URL'] + "/upward/smsActions.jsp?OID=2984&" + props.queryString2)
        ])
        .then(responseArr => {
            props.hideLoad();
            props.hidePhone();
            if(window.location.href.indexOf("CID=") > -1 && window.location.href.indexOf("solrJtid=") > -1){
                props.onFormSubmit('coreg');
            } else {
                // props.onFormSubmit('uploadResume');
                props.goResults2();
            }
        }
        , (error) => {
            props.hideLoad();
            console.log(error);
        });

    }

    return (
        <Fragment>
            <form onSubmit={props.handleSubmit(handleSubmit)} autoComplete="off">
                <div>
                    <Field component={UpwardReduxInput}
                        validate={[FormValidators.required, FormValidators.phoneNumberLength]}
                        type="text"
                        name="phone"
                        id="phone"
                        controlledValue={props.phone}
                        placeholder="(xxx) xxx - xxxx"
                        onFocus={props.phone !== "" ? () => props.updatePhone(formatPhoneChange(props.phone)) : ""}
                        onChange={e => formatNum(e)} />
                    <div className={"loading " + ( props.loading ? 'in' : '')}><div className="spinner"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></div></div>
                    <div className="text-center"><button type="submit" className="btn btnSmall fullwidth btn-block">Continue</button></div>
                </div>
            </form>
            {(((!props.hostedType.toLowerCase().toLowerCase() === "hosted" && !props.hostedType.toLowerCase() === "hosted_plus") ||  (props.hostedType.toLowerCase() === "")) && (props.qs.skip === "yes" || props.qs.skip === "x"))
            &&
            <NonHostedLinks {...props}/>
            }
        </Fragment>
    )

}


export default reduxForm({
    form: 'PhoneForm',
  })(PhoneForm);
